/**
 * 通知公告管理（noticeManagement）模块英文映射（中文原文 → 英文 扁平映射）
 * 覆盖范围：src/views/OAoffice/noticeManagement/ 下 Announcement 列表与弹窗、
 *          MyMessage、ViewAnnouncement 等
 * 术语：通知=Notice，公告=Announcement，发布=Publish，草稿=Draft，
 *       已读=Read，未读=Unread，资讯=Information，通报=Notification
 */
export default {
  '一线情报': 'Frontline Intelligence',
  '下载': 'Download',
  '业务类型': 'Business Type',
  '中': 'Medium',
  '人事任免': 'Personnel Appointments and Removals',
  '优先级': 'Priority',
  '低': 'Low',
  '全体用户': 'All Users',
  '全部已读': 'Mark All as Read',
  '公告内容': 'Announcement Content',
  '公告标题': 'Announcement Title',
  '公告类型': 'Announcement Type',
  '关闭': 'Close',
  '其他红头': 'Other Red-Head Documents',
  '创建时间': 'Created At',
  '删除': 'Delete',
  '发布': 'Publish',
  '发布人': 'Publisher',
  '发布成功': 'Published successfully',
  '发布时间': 'Publish Time',
  '填报部门': 'Reporting Department',
  '奖励通报': 'Reward Notification',
  '宏观韬略': 'Macro Strategy',
  '已读': 'Read',
  '已选择 {count} 项': '{count} items selected',
  '市场月报': 'Monthly Market Report',
  '批量操作': 'Batch Operations',
  '投资作战': 'Investment Strategy',
  '指定用户': 'Specified Users',
  '操作': 'Action',
  '操作失败': 'Operation failed',
  '文件标题': 'Document Title',
  '文件类型': 'Document Type',
  '新增': 'Add',
  '新闻资讯': 'News & Information',
  '无图片': 'No Image',
  '无文件': 'No File',
  '更多': 'More',
  '更新时间': 'Updated At',
  '未读': 'Unread',
  '查看': 'View',
  '查询': 'Query',
  '楼市早餐': 'Real Estate Morning Brief',
  '流程': 'Process',
  '流程状态': 'Process Status',
  '消息类型': 'Message Type',
  '清空': 'Clear',
  '确定': 'OK',
  '确定删除吗?': 'Are you sure you want to delete?',
  '系统消息': 'System Message',
  '编辑': 'Edit',
  '罚款通报': 'Fine Notification',
  '草稿': 'Draft',
  '行业智库': 'Industry Think Tank',
  '行政公告': 'Administrative Announcement',
  '详情': 'Details',
  '请输入公告内容': 'Please enter announcement content',
  '请输入公告标题': 'Please enter announcement title',
  '请选择业务类型': 'Please select business type',
  '请选择优先级': 'Please select priority',
  '请选择公告类型': 'Please select announcement type',
  '请选择指定用户': 'Please select specified users',
  '请选择通告对象类型': 'Please select notification target type',
  '资讯标题': 'Information Title',
  '资讯类型': 'Information Type',
  '通告': 'Notification',
  '通告对象类型': 'Notification Target Type',
  '通报标题': 'Notification Title',
  '通报类型': 'Notification Type',
  '通知公告': 'Notice & Announcement',
  '重置': 'Reset',
  '阅读人员': 'Readers',
  '阅读状态': 'Read Status',
  '附件': 'Attachment',
  '高': 'High',
};
